module.exports = __webpack_public_path__ + "img/96.054470c3.png";